// @flow
import type {Element} from 'react'
import React, {Component} from 'react'

import type {PickAlert, UpdateCallback} from 'components/proposals/types'
import FrogTipBox, {MarkdownTip} from 'components/ui/FrogTipBox'
// import {useProposalContext} from 'contexts/ProposalContext'
import {Value, Checkbox, ValueInput} from '../../ui'
import SelectDomain from './SelectDomain'
import type {Alert} from '../types'

type Props = {
  availableDomains: Object,
  body: Value,
  changeKey: string,
  destroyPolicy: boolean,
  domainDatabaseId: Value,
  isNew: boolean,
  isReadonly: boolean,
  onChange: UpdateCallback,
  organization: Object,
  pickAlert: PickAlert,
  proposal: {
    databaseId: string,
    circle: ?Object,
    tension: ?Object,
  },
  title: Value,
}

const markdownTip = () => (
  <MarkdownTip
    text={I18n.t('org_nav.tabs.overview_tab.accountabilities.markdown_tip')}
    bottomLink={I18n.t('org_nav.tabs.overview_tab.accountabilities.learn_more_link')}
  />
)

class Editor extends Component<Props> {
  static defaultProps: { isNew: boolean, isReadonly: boolean } = {
    isReadonly: false,
    isNew: false,
  }

  get isDisabled(): boolean {
    return this.props.isReadonly || this.isDestroying
  }

  get isDestroying(): boolean {
    return this.props.destroyPolicy
  }

  get titleAlert(): ?Alert {
    return this.props.pickAlert('title')
  }

  get bodyAlert(): ?Alert {
    return this.props.pickAlert('body')
  }

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Element<"div">) = () => (
    <div>
      <div className="form-group">
        <ValueInput
          alert={this.titleAlert}
          circle={this.props.proposal.circle}
          className="test-edit-policy-title"
          disabled={this.isDisabled}
          id={`EditPolicy-${this.props.changeKey}-title`}
          label={I18n.t('proposals.policy_edit.title')}
          onChange={this.props.onChange}
          organization={this.props.organization}
          path={['title']}
          strikethrough={this.isDestroying}
          autofocus
          value={this.props.title}
          aiSuggestProps={this.props.proposal ? {
            context: {type: 'proposal', id: this.props.proposal.databaseId},
            promptKey: 'suggest_proposal_policy_title',
            data: {
              tensionBody: this.props.proposal.tension?.body || '',
              circle: {ref_type: 'Circle', ref_id: this.props.proposal.circle?.databaseId},
            },
          } : undefined}
        />
      </div>
      <div className="form-group">
        <ValueInput
          mode="classic"
          alert={this.bodyAlert}
          circle={this.props.proposal.circle}
          className="test-edit-policy-body form-control textarea--medium"
          disabled={this.isDisabled}
          id={`EditPolicy-${this.props.changeKey}-body`}
          label={(
            <FrogTipBox
              withBottomSpacing
              hideDivider
              tip={markdownTip}
              target={I18n.t('proposals.policy_edit.body')}
              helpFor={I18n.t('shared.policies')}
            />
          )}
          onChange={this.props.onChange}
          organization={this.props.organization}
          path={['body']}
          strikethrough={this.isDestroying}
          textarea
          autofocus={false}
          value={this.props.body}
          placeholder={I18n.t('policies.placeholders.body')}
          aiSuggestProps={this.props.proposal.tension?.body ? {
            context: {type: 'proposal', id: this.props.proposal.databaseId},
            promptKey: 'suggest_proposal_policy_body',
            data: {
              tensionBody: this.props.proposal.tension.body || '',
              circle: {ref_type: 'Circle', ref_id: this.props.proposal.circle?.databaseId},
            },
          } : undefined}
        />
      </div>
      <div>
        <SelectDomain
          availableDomains={this.props.availableDomains}
          changeKey={`EditPolicy-${this.props.changeKey}-domain`}
          disabled={this.isDisabled}
          domainDatabaseId={this.props.domainDatabaseId}
          onChange={this.props.onChange}
          path={['domainDatabaseId']}
          strikethrough={this.isDestroying}
        />
      </div>
      {!this.props.isNew && (
        <div>
          <hr />
          <div>
            <Checkbox
              id={`${this.props.changeKey}-remove-policy`}
              checked={this.isDestroying}
              disabled={this.props.isReadonly}
              label={I18n.t('proposals.policy_edit.remove_this_policy')}
              onChange={this.props.onChange}
              tabIndex={0}
              path={['destroyPolicy']}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Editor
